<template>
  <nav v-if="isMobile" class="voyage-section-nav" aria-label="Voyage sections">
    <button
      v-for="section in sections"
      :key="section.id"
      type="button"
      class="voyage-section-pill"
      @click="scrollTo(section.id)"
    >{{ section.label }}</button>
  </nav>
</template>

<script>
const MOBILE_QUERY = '(max-width: 767.98px)';

export default {
  name: 'VoyageSectionNav',
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isMobile: false,
      mediaQuery: null,
    };
  },
  mounted() {
    this.mediaQuery = window.matchMedia(MOBILE_QUERY);
    this.isMobile = this.mediaQuery.matches;
    this.mediaQuery.addEventListener('change', this.onMediaChange);
  },
  beforeDestroy() {
    if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.onMediaChange);
  },
  methods: {
    onMediaChange(event) {
      this.isMobile = event.matches;
    },
    scrollTo(id) {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  },
};
</script>

<style scoped>
.voyage-section-nav {
  position: sticky;
  /* navbar HP sticky 70px */
  top: calc(70px + env(safe-area-inset-top, 0px));
  z-index: 1020;
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 6px 0;
  margin-bottom: 8px;
  background: var(--mz-bg);
  -webkit-overflow-scrolling: touch;
}

.voyage-section-pill {
  flex: none;
  font-size: var(--mz-fs-sm);
  line-height: 1.4;
  padding: 3px 12px;
  border: 1px solid var(--mz-border);
  border-radius: 14px;
  background: var(--mz-surface);
  color: var(--mz-text);
  white-space: nowrap;
}
</style>
